module.exports = __webpack_public_path__ + "img/Syria.4e3cbb93.png";